var HtmlComponent_default = {
  "htmlComponent": "zY6MD",
  "htmlComponent_placeholder": "hpq-C"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
